import { Organization } from '../../../core/models/organization.model';

export enum EnedisAccessRightStatus {
    NEW = 'NEW',
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    ERROR = 'ERROR',
    EXPIRED = 'EXPIRED',
    REVOKED = 'REVOKED',
}

export enum EnedisAccessRightProofType {
    FILE = 'FILE',
    MAIL = 'MAIL',
    OTHER = 'OTHER',
}
export interface EnedisAccessRightModel {
    id: string;
    clientName: string;
    clientSirenSiret?: string;
    clientRepresentativeName: string;
    clientRepresentativeEmail: string;
    clientRepresentativePhone?: string;
    pdlNumber: string;
    createdAt: Date;
    activatedAt?: Date;
    validUntil: Date;
    disabledAt?: Date;
    consumptionAccessStart?: Date;
    enedisWontReturnDailyConsumptionsAtOrBefore: Date;
    comments?: string;
    errorAt?: Date;
    errorMessage?: string;
    organization: Organization;
    status: EnedisAccessRightStatus;
    proofType: EnedisAccessRightProofType;
    revokedAt?: Date;
}

enum DomaineTensionCode {
    BTINF = 'BTINF',
    BTSUP = 'BTSUP',
    HTA = 'HTA',
    HTB = 'HTB',
}

enum ClientFinalCategorieCode {
    PRO = 'PRO',
    RES = 'RES',
}

export class AdresseInstallationModel {
    escalierEtEtageEtAppartement?: string;
    batiment?: string;
    numeroEtNomVoie?: string;
    lieuDit?: string;
    codePostal?: string;
    codeInseeCommune?: string;
}

export interface SearchpointCritereModel {
    adresseInstallation?: AdresseInstallationModel;
    numSiret?: string;
    matriculeOuNumeroSerie?: string;
    domaineTensionAlimentationCode?: DomaineTensionCode;
    nomClientFinalOuDenominationSociale?: string;
    categorieClientFinalCode?: ClientFinalCategorieCode;
    rechercheHorsPerimetre?: boolean;
}

export interface EnedisMeterEntity {
    id: string;
    localisationCode?: string;
    matricule?: string;
    ticActivee: boolean;
    ticStandard: boolean;
    ticActivable: boolean;
}

export const EnedisTechnicalDataDefinition = {
    etatContractuelCode: `ECRAC, INACCE, ECRES, IMPRO, RESIL, SERVC`,
    segmentCode: `C1 : point de connexion auquel est associé un contrat CARD.\n
C2 : point de connexion raccordé en HTA, auquel est associé un contrat unique et pour lequel la reconstitution des flux est assurée via la courbe de charge mesurée.\n
C3 : point de connexion raccordé en HTA, auquel est associé un contrat unique et pour lequel la reconstitution des flux est assurée via la courbe de charge profilée.\n
C4 : point de connexion raccordé en BT > 36 kVA et auquel est associé un contrat unique.\n
C5 : point de connexion raccordé en BT ≤ 36 kVA et auquel est associé un contrat unique.\n`,
    domaineTensionCode: `BTINF : Basse Tension Inférieure 36 KVA. \n
    BTSUP : Basse Tension Supérieure ou égale à 36 KVA. \n
    HTA : Haute tension. \n
    HTB : Très haute tension. \n`,
    typeComptageCode: 'Type de comptage du dispositif de comptage',
    plageHeuresCreuses: 'Représente la plage des heures creuses du relais',
    formuleTarifaireAcheminementCode: `
		<div class="row">
			<div class="col-sm-3" ><strong>Nomenclature</strong></div>
			<div class="col-sm-3" ><strong>Signification</strong></div>
			<div class="col-sm-3" ><strong>Correspondance</strong></div>
			<div class="col-sm-3" ><strong>Segment Opérateur de Réseau</strong></div>
		</div>
		<div class="row">
			<div class="col-sm-3" >BTINFCUST</div>
			<div class="col-sm-3" >Basse Tension Inférieure 36 KVA Courtes Utilisations Simple Tarif</div>
			<div class="col-sm-3" >Sites ayant une puissance inférieure à 36kVA en Courtes Utilisations et sur 1 poste de consommations (Base)</div>
			<div class="col-sm-3" rowspan="5" >C5</div>
		</div>
		<div class="row">
			<div class="col-sm-3">BTINFMUDT</div>
			<div class="col-sm-3">Basse Tension Inférieure 36 KVA Moyennes Utilisations Double Tarif</div>
			<div class="col-sm-3">Sites ayant une puissance inférieure à 36kVA en Moyennes Utilisations et sur 2 postes de consommations (Heures Creuses/Heures Pleines)</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >BTINFLU</div>
			<div class="col-sm-3" >Basse Tension Inférieure 36 KVA Longues Utilisations</div>
			<div class="col-sm-3" >Sites ayant une puissance inférieure à 36kVA en Longues Utilisations (concerne principalement les éclairages publics)</div>
		</div>
		<div class="row">
			<div class="col-sm-3">BTINFCU4</div>
			<div class="col-sm-3">Basse Tension Inférieure 36 KVA Courtes Utilisations 4 postes</div>
			<div class="col-sm-3">Sites ayant une puissance inférieure à 36kVA en Courtes Utilisations et sur 4 postes de consommations (Haute Saison Heures Creuses/Heures Pleines et Basse saison Heures Creuses/Heures Pleines)</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >BTINFMU4</div>
			<div class="col-sm-3" >Basse Tension Inférieure 36 KVA Moyennes Utilisations 4 postes</div>
			<div class="col-sm-3" >Sites ayant une puissance inférieure à 36kVA en Moyennes Utilisations et sur 4 postes de consommations (Haute Saison Heures Creuses/Heures Pleines et Basse saison Heures Creuses/Heures Pleines)</div>
		</div>
		<div class="row">
			<div class="col-sm-3">BTSUPCU4</div>
			<div class="col-sm-3">Basse Tension Supérieure 36 KVA Courtes Utilisations 4 postes</div>
			<div class="col-sm-3">Sites ayant une puissance supérieure à 36kVA et inférieure à 250 kW en Courtes Utilisations et sur 4 postes de consommations (Heures Creuses Hiver/Heures Pleines Hiver et Heures Creuses Eté/Heures Pleines Eté)</div>
			<div class="col-sm-3" rowspan="2">C4</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >BTSUPLU4</div>
			<div class="col-sm-3" >Basse Tension Supérieure 36 KVA Longues Utilisations 4 postes</div>
			<div class="col-sm-3" >Sites ayant une puissance supérieure à 36kVA et inférieure à 250 kW en Longues Utilisations et sur 4 postes de consommations (Heures Creuses Hiver/Heures Pleines Hiver et Heures Creuses Eté/Heures Pleines Eté)</div>
		</div>
		<div class="row">
			<div class="col-sm-3">HTACU5</div>
			<div class="col-sm-3">Haute Tension Courtes Utilisations 5 postes</div>
			<div class="col-sm-3">Sites ayant une puissance supérieure à 250kW en Courtes Utilisations et sur 5 postes de consommations (Pointe, Heures Creuses Hiver/Heures Pleines Hiver, Heures Creuses Eté/Heures Pleines Eté)</div>
			<div class="col-sm-3" rowspan="2" >C2-C3</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >HTALU5</div>
			<div class="col-sm-3" >Haute Tension Longues Utilisations 5 postes</div>
			<div class="col-sm-3" >Sites ayant une puissance supérieure à 250kW en Longues Utilisations et sur 5 postes de consommations (Pointe, Heures Creuses Hiver/Heures Pleines Hiver, Heures Creuses Eté/Heures Pleines Eté)</div>
		</div>
		<div class="row">
			<div class="col-sm-3">HTALU 5PM</div>
			<div class="col-sm-3">Haute Tension Longues Utilisations 5 postes avec Pointe Mobile</div>
			<div class="col-sm-3">Sites ayant une puissance supérieure à 250kW en Longues Utilisations et sur 5 postes de consommations (Pointe Mobile, Heures Creuses Hiver/Heures Pleines Hiver, Heures Creuses Eté/Heures Pleines Eté)</div>
			<div class="col-sm-3">C2</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >HTB 1</div>
			<div class="col-sm-3" >Très Haute Tension</div>
			<div class="col-sm-3" >Sites ayant étant rattachés au périmètre RTE</div>
			<div class="col-sm-3" rowspan="3" >C1</div>
		</div>
		<div class="row">
			<div class="col-sm-3">HTB 2</div>
			<div class="col-sm-3">Très Haute Tension</div>
			<div class="col-sm-3">Sites ayant étant rattachés au périmètre RTE</div>
		</div>
		<div class="row">
			<div class="col-sm-3" >HTB 3</div>
			<div class="col-sm-3" >Très Haute Tension</div>
			<div class="col-sm-3" >Sites ayant étant rattachés au périmètre RTE</div>
		</div>
	`,
};

export interface EnedisTechnicalDataModel {
    id: string;
    pdlId: string;
    etatContractuelCode?: string;
    escalierEtEtageEtAppartement?: string;
    numeroEtNomVoie?: string;
    codePostal?: string;
    communeCode?: string;
    dateDerniereModificationFormuleTarifaireAcheminement?: Date;
    segmentCode?: string;
    niveauOuvertureServices?: string;
    domaineTensionCode?: string;
    tensionLivraisonCode?: string;
    puissanceRaccordementSoutirageValeur?: number;
    puissanceRaccordementSoutirageUnite?: string;
    formuleTarifaireAcheminementCode?: string;
    puissanceSouscriteMaxValeur?: number;
    puissanceSouscriteMaxUnite?: string;
    calendrierFrnCode?: string;
    typeComptageCode?: string;
    disjoncteurCalibreCode?: string;
    plageHeuresCreuses?: string;
    caracteristiquesRelevePeriodiciteCode?: string;
    futuresPlagesHeuresCreusesCode?: string;
    futuresPlagesHeuresCreuses?: string;
    meters: EnedisMeterEntity[];
}

export enum EnedisConsumptionTypeSerie {
    TURPE = 'TURPE',
    FRN = 'FRN',
}

export enum EnedisConsumptionStep {
    DAILY = '1D',
    MONTHLY = '1M',
    YEARLY = '1Y',
}

export const EnedisConsumptionStepLabel: Record<EnedisConsumptionStep, string> = {
    [EnedisConsumptionStep.DAILY]: 'Quotidien',
    [EnedisConsumptionStep.MONTHLY]: 'Mensuel',
    [EnedisConsumptionStep.YEARLY]: 'Annuel',
};

export interface EnedisConsumptionModel {
    id: number;
    dateStart: Date;
    typeSerie: string;
    dateEnd: Date;
    consumptionkWh: number;
    accessRight: EnedisAccessRightModel;
    consumptionDetail: EnedisConsumptionDetailModel[];
    createdAt: Date;
}

export interface EnedisConsumptionDetailModel {
    id: number;
    temporalClass: string; // exemple : BASE, HC, HPB, etc.
    nature: string;
    declencheur: string;
    statut: string;
    consumptionkWh: number;
}

export interface EnedisSearchPointModel {
    attributes: { id: string };
    adresseInstallationNormalisee: {
        ligne1?: string;
        ligne2?: string;
        ligne3?: string;
        ligne4?: string;
        ligne5?: string;
        ligne6?: string;
        ligne7?: string;
    };
    matricule?: string;
    numeroSerie?: string;
    typeComptage?: {
        attributes?: { code: string };
        libelle: string;
    };
    etatContractuel: {
        attributes?: { code: string };
        libelle: string;
    };
    nomClientFinalOuDenominationSociale?: string;
}

export enum EnedisPowerMeanStep {
    PT5M = 'PT5M',
    PT10M = 'PT10M',
    PT15M = 'PT15M',
    PT30M = 'PT30M',
    PT60M = 'PT60M',
}

export const EnedisPowerMeanStepLabel: Record<EnedisPowerMeanStep, string> = {
    [EnedisPowerMeanStep.PT5M]: '5 minutes',
    [EnedisPowerMeanStep.PT10M]: '10 minutes',
    [EnedisPowerMeanStep.PT15M]: '15 minutes',
    [EnedisPowerMeanStep.PT30M]: '30 minutes',
    [EnedisPowerMeanStep.PT60M]: '60 minutes',
};

export enum EnedisPowerNature {
    RAW = 'B', // BRUT
    CORRECTED = 'C', // CORRIGÉ
    ACTUAL = 'R', // RÉEL
    RECONSTITUTED = 'H', // RECONSTITUÉ
    RECONSTITUTED_AND_GRID_OUTAGE = 'P', // RECONSTITUÉ_ET_COUPURE_SECTEUR
    MANUALLY_IMPORTED_BY_ENEDIS = 'D', // IMPORTÉ_MANUELLEMENT_PAR_ENEDIS
    GRID_OUTAGE = 'S', // COUPURE_SECTEUR
    SHORT_GRID_OUTAGE = 'T', // COUPURE_SECTEUR_COURTE
    GRID_OUTAGE_START = 'F', // DÉBUT_COUPURE_SECTEUR
    GRID_OUTAGE_END = 'G', // FIN_COUPURE_SECTEUR
    ESTIMATED = 'E', // ESTIMÉ
}

export enum EnedisPowerIndicatorConfidence {
    VALID = '0', // VALIDE
    QUESTIONABLE = '1', // SUJETTE_À_CAUTION
    WITH_COMPLEMENTARY_STATE = '2', // ÉTAT_COMPLÉMENTAIRE
}

export enum EnedisPowerComplementaryState {
    NONE = '0', // AUCUN
    GRID_OUTAGE = '1', // COUPURE_SECTEUR
    GRID_RECOVERY = '5', // REPRISE_SECTEUR
    TIME_CORRECTION = '6', // CORRECTION_HEURE
    POWER_SUM_CORRECTION = '7', // SOMME_PUISSANCES
    METER_OUT_OF_SYNC = '8', // COMPTEUR_NON_SYNCHRO
    GRID_RECOVERY_AND_METER_OUT_OF_SYNC = '9', // REPRISE_SECTEUR_ET_COMPTEUR_NON_SYNCHRO
    TIME_AND_POWER_SUM_CORRECTION = '10', // CORRECTION_HEURE_ET_SOMME_PUISSANCES
    GRID_OUTAGE_THEN_RECOVERY = '11', // COUPURE_PUIS_REPRISE_SECTEUR
}

export interface EnedisPowerDataPoint {
    dateStart: Date;

    powerValue: number;

    step: EnedisPowerMeanStep;

    nature: EnedisPowerNature;

    indicatorConfidence: EnedisPowerIndicatorConfidence;

    complementaryState: EnedisPowerComplementaryState;
}

export enum EnedisPowerBusinessMetric {
    CONS = 'CONS',
    PROD = 'PROD',
}

export const EnedisPowerBusinessMetricLabels: Record<EnedisPowerBusinessMetric, string> = {
    [EnedisPowerBusinessMetric.CONS]: 'Soutirage',
    [EnedisPowerBusinessMetric.PROD]: 'Injection',
};

export enum EnedisPowerUnit {
    SECOND = 's', // Si j'amais un jour in tombe là dessus, je serais curieux !
    WATT_HOUR = 'Wh', // énergie active (watt-heure)
    WATT = 'W', // puissance active (watt)
    VOLT_AMPERE = 'VA', // puissance apparente (volt-ampère)
    VAR_HOUR = 'VArh', // énergie réactive (volt-ampère réactif heure)
}

export enum EnedisPowerPhysicalMetric {
    ACTIVE_POWER = 'PA', // Returned by ENEDIS but not in dictionnary ?
    ACTIVE_ENERGY = 'EA', // énergie active
    REACTIVE_ENERGY = 'ER', // énergie réactive
    REACTIVE_ENERGY_CAPACITIVE = 'ERC', // énergie réactive capacitive
    REACTIVE_ENERGY_INDUCTIVE = 'ERI', // énergie réactive inductive
    OVERRUN_DURATION = 'DD', // durée de dépassement
    ENERGY_OVERRUN = 'DE', // dépassement énergétique
    QUADRATIC_OVERRUN = 'DQ', // dépassement quadratique
    MAXIMUM_POWER_REACHED = 'PMA', // puissance maximale atteinte
    OPERATING_TIME = 'TF', // temps de fonctionnement
}

export enum EnedisPowerMeasuresType {
    PMAX = 'PMAX',
    PMEAN = 'COURBE',
}

export const EnedisPowerMeasuresTypeLabel: Record<EnedisPowerMeasuresType, string> = {
    [EnedisPowerMeasuresType.PMAX]: 'Puissances Max',
    [EnedisPowerMeasuresType.PMEAN]: 'Puissances moyennes',
};

export interface EnedisPowerData {
    accessRight: EnedisAccessRightModel;

    measuresType: EnedisPowerMeasuresType;

    powerUnit: EnedisPowerUnit;

    businessMetric: EnedisPowerBusinessMetric;

    physicalMetric: EnedisPowerPhysicalMetric;

    points: EnedisPowerDataPoint[];
}

export enum EnedisPowerMaxStep {
    DAILY = 'P1D',
    MONTHLY = 'P1M',
}
export const EnedisPowerMaxStepLabel: Record<EnedisPowerMaxStep, string> = {
    [EnedisPowerMaxStep.DAILY]: 'Quotidien',
    [EnedisPowerMaxStep.MONTHLY]: 'Mensuel',
};
